<!--改制目录列表-->
<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="产品大类" prop="oneLName">
                            <el-input v-model="formInline.oneLName" placeholder="请输入"
                                      clearable style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="链群" prop="lianqunCode">
                            <brselect
                                style="width:100%;"
                                category="xsyb_lianqun"
                                :v="formInline.lianqunCode"
                                v-model="formInline.lianqunCode"
                                clearable
                                placeholder="--请选择--">
                            </brselect>
                        </el-form-item>
                        <el-form-item label="改制目录" prop="specificDivision">
                            <el-input v-model="formInline.specificDivision" placeholder="请输入"
                                      clearable style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="改制描述" prop="specificReform">
                            <el-input v-model="formInline.specificReform" placeholder="请输入"
                                      clearable style="width: 100%"></el-input>
                        </el-form-item>
                    </div>
                    <el-collapse-transition>
                        <div v-show="isScreen">
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="备注" prop="remark">
                                    <el-input v-model="formInline.remark" placeholder="请输入"
                                              clearable style="width: 100%"></el-input>
                                </el-form-item>
                                <el-form-item label="操作时间" class="timeselect" style="width: 50%;">
                                    <el-date-picker
                                        placeholder="请选择"
                                        v-model="formInline.startTime"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                    <span class="w-time-to">至</span>
                                    <el-date-picker
                                        placeholder="请选择"
                                        v-model="formInline.endTime"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="改制类型">
                                    <el-select v-model="formInline.specificType"
                                               placeholder="请选择"
                                               clearable>
                                        <el-option label="内销" value="1"></el-option>
                                        <el-option label="外销" value="2"></el-option>
                                        <el-option label="内外销通用" value="3"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </el-collapse-transition>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createReformCatalog">
                            新增
                        </el-button>
                    </div>
                </div>
            </div>
            <!--数据展示-->
            <div class="h-table h-mrt30">
                <el-table
                    :data="tableData"
                    ref="multipleTable"
                    :border="true"
                    style="width: 100%"
                    max-height="450"
                >
                    <el-table-column
                        label="产品大类编码"
                        prop="oneLId"
                        width="105"
                        fixed="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="产品大类名称"
                        prop="oneLName"
                        width="105"
                        fixed="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="链群"
                        prop="lianqunName"
                        width="90"
                        fixed="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="改制目录"
                        prop="specificDivision"
                        width="200"
                        fixed="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="改制描述"
                        prop="specificReform"
                        width="200"
                        fixed="left"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="单台加价"
                        prop="reformPrice"
                        width="100"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="备注"
                        prop="remark"
                        width="100"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="改制类型"
                        width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{
                                {
                                    '1': '内销',
                                    '2': '外销',
                                    '3': '内外销通用'
                                }[scope.row.specificType] || scope.row.specificType
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="审核状态"
                        width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{
                                scope.row.status === 2
                                    ? '审核通过'
                                    : scope.row.instid
                                        ? ({'0': '审核中', '1': '驳回'}[scope.row.status] || scope.row.status)
                                        : '暂存'
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        prop="cucode"
                        width="150"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.cuname + "[" + scope.row.cucode + "]" }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建时间"
                        prop="cdate"
                        width="110"
                        :formatter="formatDate"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="修改人编码"
                        prop="lucode"
                        width="100"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="修改时间"
                        prop="ldate"
                        width="100"
                        :formatter="formatDate"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        width="220"
                        label="操作">
                        <template slot-scope="scope">
                            <div style="display: flex;align-items: center;justify-content: center;">
                                <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.instid && scope.row.instid !== ''"
                                    style="margin-left: 0;"
                                    @click="genzongLiuch(scope.row)">
                                    跟踪审批
                                </el-button>
                                <el-button
                                    size="small" class="h-tableLink h-btn"
                                    v-if="userCode === scope.row.cucode || (scope.row.cucode === null || scope.row.cucode === undefined)"
                                    style="margin-left: 0;"
                                    @click="updateOpen(scope.row)">
                                    修改
                                </el-button>
                                <el-button
                                    size="small" class="h-tableLink h-btn"
                                    style="margin-left: 0;"
                                    @click="checkOpen(scope.row)">
                                    查看
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableBL">
                    <el-button type="primary" @click="exportExcel">批量导出</el-button>
                </div>
                <div class="h-pagination2">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>
        <viewhistory :visible.sync="showHistory" v-if="showHistory" :id="instId"/>
<!--        <create-page :visible.sync="showCreate" v-if="showCreate" @close="closeCreate"/>-->
<!--        <detail-page :visible.sync="showDetail" v-if="showDetail" :reformCatalogId="reformCatalogId" @close="closeDetail"/>-->
        <el-dialog
            :visible="showCreate || showDetail || showUpdate"
            :close-on-click-modal="false"
            class="h-dialog2"
            @close="handleDialogClose"
        >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1 v-if="showCreate">新增改制目录</h1>
                        <h1 v-else-if="showDetail">改制目录详情</h1>
                        <h1 v-else>修改改制目录</h1>
                    </div>
                </div>
            </div>
            <div class="h-formL ines">
                <div style="padding: 12px;" class="dialogout create-reform-catalog">
                    <el-form :model="saveData" label-position="right" ref="saveData" :inline="true"
                             class="demo-ruleForm h-formbLine h-formbLine1">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceCon2">
                                    <div class="h-formLine" style="margin-right:60px">
                                        <el-form-item  label="产品大类编码" class="h-elformWrap-2" label-width="100" prop="oneLId" :rules="[{ required: true, message: '请选择产品大类', trigger: 'blur'},]">
                                            <el-select value-key="id" filterable  v-model="saveData.oneLId" placeholder="请选择" @change="getOneLName" :disabled="showDetail" style="width:1.8rem">
                                                <el-option v-for="item in allOne" :key="item.oneLId"  :label="`[${item.oneLId}] ${item.oneLName}`" :value="item.oneLId"  >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="产品大类名称" class="h-elformWrap-2" required>
                                            <el-input placeholder="自动带出" v-model="saveData.oneLName" readonly :disabled="showDetail" style="width:1.8rem"></el-input>
                                        </el-form-item>
                                        <el-form-item label="链群" class="h-elformWrap-2" :rules="[{ required: true, message: '请选择链群', trigger: 'blur'},]">
                                            <el-select v-model="saveData.lianqunCode" placeholder="请选择" @change="getLianqunName" :disabled="showDetail" style="width:1.8rem">
                                                <el-option v-for="item in allLianqun" :key="item.lianqunCode" :label="item.lianqunName" :value="item.lianqunCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="改制类型" class="h-elformWrap-2" required>
                                            <el-select v-model="saveData.specificType" placeholder="请选择" :clearable="true" :disabled="showDetail" style="width:1.8rem">
                                                <el-option value="1" label="内销"></el-option>
                                                <el-option value="2" label="外销"></el-option>
                                                <el-option value="3" label="内外销通用"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="改制目录名称" class="h-elformWrap-1" required>
                                            <el-input placeholder="请输入" v-model="saveData.specificDivision" :disabled="showDetail"></el-input>
                                        </el-form-item>
                                        <el-form-item label="改制要求" class="h-elformWrap-1" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                                            <el-input placeholder="请输入" v-model="saveData.specificReform" :disabled="showDetail"></el-input>
                                        </el-form-item>
                                        <el-form-item label="单台加价" class="h-elformWrap-2" :rules="[{ required: true, message: '必须输入单台加价', trigger: 'blur'},]">
                                            <el-input placeholder="请输入" v-model.number="saveData.reformPrice" :disabled="showDetail" style="width:1.8rem"></el-input>
                                        </el-form-item>
                                        <el-form-item label="备注" class="h-elformWrap-2">
                                            <el-input v-model="saveData.remark" :disabled="showDetail" style="width:1.8rem"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div style="display:flex;justify-content:center;margin-bottom:20px">
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="handleBeforeClose">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="submitFlage('暂存')" v-if="showCreate || (showUpdate && this.saveData.instid === '')">暂存</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitFlage('提交')" v-if="showCreate || showUpdate">确认提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import _ from "loadsh";
import reduceCost from "@/api/invoice/reduceCost";
import updownfile from "@/utils/updownfile";
import createPage from "./createReformCatalog.vue";
import detailPage from "./reformCatalogDetailPage.vue";
import specificCatalogue from "@/api/reform/specificCatalogue";

export default {
    components: { createPage, detailPage },
    data() {
        return {
            userCode: "",
            formInline: {
                oneLName: '',
                lianqunCode: '',
                specificDivision: '',
                specificReform: '',
                specificType: '',
                remark: '',
                startTime: '',
                endTime: '',
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
            saveData:{
                id:'',
                instid: '',
                lianqunCode:'',
                lianqunName:'',
                oneLId:'',
                oneLName:'',
                specificDivision:'',
                specificReform:'',
                reformPrice:0,
                remark:'',
                specificType:'',
            },
            // 存放所有大类，新增改制条目时用
            allOne:[],
            // 存放所有链群，新增改制条目时用
            allLianqun:[],
            isScreen: false,
            closeScreen: require("@/assets/images/pimg/closeallic.png"),
            drawScreen: require("@/assets/images/pimg/dobleArr.png"),
            instId: '',
            showHistory: false,
            showCreate: false,
            showDetail: false,
            showUpdate: false,
            reformCatalogId: '',
            tableData: []
        }
    },
    methods: {
        // 清空saveData
        clearSaveData(){
            this.saveData= {
                id:'',
                instid: '',
                lianqunCode:'',
                lianqunName:'',
                oneLId:'',
                oneLName:'',
                specificDivision:'',
                specificReform:'',
                reformPrice:0,
                remark:'',
                specificType:'',
            };
        },
        // 打开创建 reform catalog
        createReformCatalog() {
            console.log('打开创建 reform catalog');
            this.showCreate = true;
            this.clearSaveData();
            if(this.allOne.length===0){
                //查询所有链群
                specificCatalogue.selectAllOne().then(rd => {
                    this.allOne = rd;
                })
            }
        },
        // 关闭对话框
        handleDialogClose() {
            this.showCreate = false;
            this.showDetail = false;
            this.showUpdate = false;
        },
        // 获取链群名称
        getOneLName(q){
            //获取name
            const one = _.find(this.allOne,{oneLId:q})
            this.saveData.oneLName = one.oneLName;
            this.selectAllDivision(q);
        },
        // 查询所有链群
        selectAllDivision(oneLId){
            //查询所有改制目录
            specificCatalogue.selectAllDivision({oneLId: oneLId}).then(rd => {
                //过滤出所有可选链群
                this.allLianqun = [];
                this.saveData.lianqunCode='';
                this.saveData.lianqunName='';
                for (let item of rd) {
                    if (this.allLianqun.findIndex(item => item.lianqunCode=== item.lianqunCode) === -1) {
                        this.allLianqun.push(item);
                    }
                }
                this.saveData.lianqunCode = this.allLianqun[0].lianqunCode;
                this.getLianqunName(this.saveData.lianqunCode);
            })
        },
        // 获取链群名称
        getLianqunName(q){
            //获取name
            const lianqun = _.find(this.allLianqun,{lianqunCode:q})

            this.saveData.lianqunName = lianqun.lianqunName;
            console.log("this.saveData.oneLName",this.saveData.lianqunName)
        },
        // 提交
        submitFlage(data){
            if (this.saveData.specificDivision === '') {
                return this.$msg.msge("改制目录名称不能为空!");
            }
            if (this.saveData.specificReform === '') {
                return this.$msg.msge("改制要求不能为空!");
            }
            if (this.saveData.reformPrice === '' || this.saveData.reformPrice === undefined) {
                return this.$msg.msge("单台加价不能为空!");
            }
            if (this.saveData.specificType === '') {
                return this.$msg.msge("改制类型不能为空!");
            }
            if (this.saveData.lianqunCode === '') {
                return this.$msg.msge("链群不能为空!");
            }
            if (this.saveData.oneLId === '') {
                return this.$msg.msge("产品大类不能为空!");
            }
            if(data === '提交'){
                this.subTo();
            }else {
                this.saveTo();
            }
        },
        saveTo() {
            reduceCost.insertReformCatalog(this.saveData).then(rd => {
                this.$msg.msgs(rd.msg);
                if (rd.f) {
                    this.handleBeforeClose();
                }
            })
        },
        subTo() {
            this.$msg.confirm("确认提交?", () => {
                reduceCost.submitNew(this.saveData).then(rd => {
                    this.$msg.msgs(rd.msg);
                    if (rd.f) {
                        this.handleBeforeClose();
                    }
                })
            })
        },
        // 获取 ReformCatalog 详情
        getReformCatalogDetail(id) {
            reduceCost.getReformCatalogDetail({id: id}).then(rd => {
                if (rd.obj !== null) {
                    this.saveData = rd.obj;
                    if (this.saveData.oneLId !== undefined && this.saveData.oneLId !== '') {
                        this.selectAllDivision(this.saveData.oneLId);
                    }
                }
            })
        },
        handleBeforeClose() {
            console.log('关闭创建 dialog');
            if (this.showCreate || this.showUpdate) {
                this.query();
            }
            this.showCreate = false;
            this.showDetail = false;
            this.showUpdate = false;
        },
        checkOpen(row) {
            console.log("这是跳转详情，" + row.id)
            this.reformCatalogId = row.id + "";
            this.showDetail = true;
            if(this.allOne.length===0){
                //查询所有链群
                specificCatalogue.selectAllOne().then(rd => {
                    this.allOne = rd;
                })
            }
            this.getReformCatalogDetail(this.reformCatalogId);
        },
        closeDetail() {
            this.showDetail = false;
        },
        exportExcel() {
            updownfile.down("/api/swyl/v1/reform/bscSpecificCatalogue/downloadReformCatalogExcel", this.formInline, "get", 'data');
        },
        updateOpen(row) {
            console.log("这是跳转编辑，" + row.id)
            // this.$router.push({
            //     path: '/invoice/updateReformCatalog',
            //     query: {reformCatalogId: row.id}
            // })
            this.reformCatalogId = row.id + "";
            this.showUpdate = true;
            if(this.allOne.length===0){
                //查询所有链群
                specificCatalogue.selectAllOne().then(rd => {
                    this.allOne = rd;
                })
            }
            this.getReformCatalogDetail(this.reformCatalogId);
        },
        query() {
            reduceCost.selectListPage(this.formInline).then(res => {
                this.tableData = res.records;
                this.formInline.total = res.total;
            })
        },
        // 展开折叠
        collapseChange() {
            this.isScreen = !this.isScreen;
        },
        handleFilter() {
            this.formInline.pageNo = 1;
            this.query()
        },
        resetData() {
            this.formInline = {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            }
            this.query()
        },
        genzongLiuch(v) {
            console.log(v.instid);
            this.instId = v.instid;
            this.showHistory = true;
        },
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property]
            if(data == null || data === '') {
                return null
            }
            let dt = new Date(data)
            return this.$util.riQi3(dt);
        },
    },
    created() {
        this.userCode = this._user.usercode;
        this.query();
    },
    activated() {
        this.query()
    }
}
</script>
<style>
    .width .el-form-item__label {
        vertical-align: top;
    }

    .width .el-date-editor .el-range-separator {
        width: 9%;
        margin-bottom: 7px;
    }

    .create-reform-catalog .h-formbLine .h-elformWrap-2 {
        padding-right: 0.5rem;
        width: 50% !important;
    }
    .create-reform-catalog .h-formbLine .h-elformWrap-1 {
        padding-right: 0;
        width: 100% !important;
    }
    .create-reform-catalog .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 22%;
    }
    .create-reform-catalog .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }
    .create-reform-catalog .h-formbLine .el-form-item__label {
        width: 51%;

    }
    .create-reform-catalog .h-formbLine .el-form-item__content {
        width: 49%;
    }
</style>
<style scoped lang="scss">
    ::v-deep(.create-reform-catalog .h-formbLine .h-elformWrap-2 .el-form-item__label) {
        width: 57%;
    }
    ::v-deep(.create-reform-catalog .h-formbLine .h-elformWrap-2 .el-form-item__content) {
        width: 43%;
    }
    ::v-deep(.create-reform-catalog .h-formbLine .h-elformWrap-1 .el-form-item__label) {
        width: 24%;
    }
    ::v-deep(.create-reform-catalog .h-formbLine .h-elformWrap-1 .el-form-item__content) {
        width: 76%;
    }
    .h-dialogImg{
        height: hw(162);
        background: url(../../../assets/images/h-dialogImg.png) center no-repeat;
        background-size: hw(1080);
        padding-left: hw(602);
        h1{
            font-size: hw(30);
            color: #fff;
            font-weight: normal;
            letter-spacing: hw(2);
        }
        p{
            font-size: hw(24);
            color: #fff;
            margin-top: hw(10);
            letter-spacing: hw(2);
        }
    }
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;
        }
        .steps{
            position: absolute;
            z-index: 1;
        }
        .step1{
            top: 6.55rem;
            left: 2.75rem;
            width:10.8rem;
            height: 1.7rem;
        }
        .step2{
            top: 6.5rem;
            right: 2.4rem;
            width: 2.6rem;
            height: 1.8rem;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>